module.exports = require("@swa-ui/core/src/LoadingDepiction/DepictionRow.module.scss");